
// ✅ Services.jsx
import React, { useEffect, useState } from 'react';
import FlipCard from './FlipCard';
import wordpressIcon from "../assets/logos/wordpress.png";
import shopifyIcon from "../assets/logos/shopify.png";
import fullstackIcon from "../assets/fullstack.png";
import ecommerceIcon from "../assets/logos/shopping.png"
import domainIcon from "../assets/logos/server.png"
import androidIcon from "../assets/logos/android.png"
import iosIcon from "../assets/logos/apple.png"
import googleAdsIcon from "../assets/logos/adwords.png";
import facebookAdsIcon from "../assets/logos/ads.png";
import seoIcon from "../assets/logos/seo.png";
import emailIcon from "../assets/logos/email-marketing.png";
import socialMediaIcon from "../assets/logos/social-media2.png";
import analyticsIcon from "../assets/logos/monitor.png";


import uiuxIcon from "../assets/logos/uiux.png";
import logoIcon from "../assets/logos/logobird.png";
import cardIcon from "../assets/logos/visiting.png";
import brandingIcon from "../assets/logos/customerbranding.png";
import socialPostIcon from "../assets/logos/socialmediapost.png";
import festivalIcon from "../assets/logos/poster.png";


import '../App.css';
import "../ServicesSlider.css";
import CircularProgress from './CircularProgress';
import SEO from '../components/SEO';

const Services = () => {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const [activeCard, setActiveCard] = useState(null);

  const services = [
    {
      id: 1,
      frontIcon: wordpressIcon,
      frontTitle: "WordPress Development",
      backText: "SEO-optimized WordPress sites with high performance and scalability.",
      borderColor: "#3b82f6", // Blue
    },
    {
      id: 2,
      frontIcon: shopifyIcon,
      frontTitle: "Shopify Development",
      backText: "Custom Shopify themes, plugins, and SEO-friendly storefronts.",
      borderColor: "#10b981", // Green
    },
    {
      id: 3,
      frontIcon: ecommerceIcon,
      frontTitle: "E-commerce Development",
      backText: "Build scalable, conversion-focused online stores with SEO best practices.",
      borderColor: "#f59e0b", // Yellow-orange
    },
    {
      id: 4,
      frontIcon: fullstackIcon,
      frontTitle: "Full Stack Development",
      backText: "End-to-end MERN solutions with responsive UI and SEO integration.",
      borderColor: "#9ca3af", // Light gray / white-gray
    },
    {
      id: 5,
      frontIcon: domainIcon,
      frontTitle: "Domain & Hosting",
      backText: "Secure, fast hosting with free domain setup and SEO tools.",
      borderColor: "#f19c79", // Cream
    },
  ];

  const graphics = [
    {
      id: 14,
      frontIcon: uiuxIcon, // Replace with your actual icon
      frontTitle: "UI/UX Design",
      backText: "Intuitive user interfaces and seamless user experiences for web and mobile apps.",
      borderColor: "#3B82F6", // Blue
    },
    {
      id: 15,
      frontIcon: logoIcon, // Replace with your actual icon
      frontTitle: "Logo Design",
      backText: "Memorable and impactful logo designs that represent your brand identity.",
      borderColor: "#FBBF24", // Yellow
    },
    {
      id: 16,
      frontIcon: cardIcon, // Replace with your actual icon
      frontTitle: "Business Card Design",
      backText: "Professional and modern business card layouts that leave a lasting impression.",
      borderColor: "#10B981", // Green
    },
    {
      id: 17,
      frontIcon: brandingIcon, // Replace with your actual icon
      frontTitle: "Custom Branding",
      backText: "Comprehensive branding packages tailored to your business personality.",
      borderColor: "#9ca3af", // Light Gray / White-gray
    },
    {
      id: 18,
      frontIcon: socialPostIcon, // Replace with your actual icon
      frontTitle: "Social Media Post Design",
      backText: "Eye-catching post templates that drive engagement across social platforms.",
      borderColor: "#8B5CF6", // Purple / brand accent
    },
    {
      id: 19,
      frontIcon: festivalIcon, // Replace with your actual icon
      frontTitle: "Festival Post Design",
      backText: "Vibrant and festive creatives tailored to Indian & global cultural events.",
      borderColor: "#F97316", // Orange
    },
  ];



  const apps = [
    {
      id: 6,
      frontIcon: androidIcon,
      frontTitle: "Android Development",
      backText: "Native Android apps with clean UI, optimized performance, and seamless integration with Android services.",
      borderColor: "#10b981", // green
    },
    {
      id: 7,
      frontIcon: iosIcon,
      frontTitle: "IOS Development",
      backText: "Elegant iOS applications built using Swift with smooth UX and App Store compliance.",
      borderColor: "#dd2d4a", // red
    },

  ]

  const digital = [
    {
      id: 8,
      frontIcon: googleAdsIcon, // Replace with your actual icon
      frontTitle: "Google Ads",
      backText: "Targeted ad campaigns on Google to drive traffic and increase conversions.",
      borderColor: "#FBBF24", // Google Blue
    },
    {
      id: 10,
      frontIcon: seoIcon, // Replace with your actual icon
      frontTitle: "SEO",
      backText: "Boost search engine rankings through on-page, off-page, and technical SEO strategies.",
      borderColor: "#9ca3af", // Tailwind Green
    },
    {
      id: 9,
      frontIcon: facebookAdsIcon, // Replace with your actual icon
      frontTitle: "Facebook Ads",
      backText: "Engaging ad creatives and targeting to reach the right audience on Facebook & Instagram.",
      borderColor: "#dd2d4a", // Facebook Blue
    },
    {
      id: 11,
      frontIcon: emailIcon, // Replace with your actual icon
      frontTitle: "E-mail Marketing",
      backText: "Automated and personalized email campaigns that convert leads into customers.",
      borderColor: "#FBBF24", // Tailwind Yellow
    },
    {
      id: 13,
      frontIcon: analyticsIcon, // Replace with your actual icon
      frontTitle: "Analytics & Reporting",
      backText: "Track performance, monitor KPIs, and get actionable insights from your digital campaigns.",
      borderColor: "#3B82F6", // Tailwind Blue
    },
    {
      id: 12,
      frontIcon: socialMediaIcon, // Replace with your actual icon
      frontTitle: "Social Media Marketing",
      backText: "Content-driven strategies to grow your brand on platforms like Instagram, LinkedIn, and Twitter.",
      borderColor: "#9ca3af", // White
    },
  ];



  return (
    <div className="content py-10">
      <SEO
        title="Services | Lavanya Infotech"
        description="Discover the range of IT services offered by Lavanya Infotech, including web development, UI/UX design, branding, e-commerce solutions, SEO, and digital marketing."
      />

      <h1 className="title font-poppins text-4xl sm:text-5xl text-center font-bold">
        Services
        <div className="aurora text-3xl">
          <div className="aurora__item"></div>
          <div className="aurora__item"></div>
          <div className="aurora__item"></div>
          <div className="aurora__item"></div>
        </div>
      </h1>

      <div className="text-slider pt-2 mt-10 text-center mb-10">
        <div className="animated-texts">
          <span className="animated-item text-blue-300 border-b-4 border-blue-300">Web Development</span>
          <span className="animated-item text-green-300 border-b-4 border-green-300">SEO Services</span>
          <span className="animated-item text-purple-300 border-b-4 border-purple-300">App Development</span>
          <span className="animated-item text-yellow-300 border-b-4 border-yellow-300">Digital Marketing</span>
        </div>
      </div>


      <div className='xyz'>
        <h1 className="font-poppins text-2xl sm:text-3xl md:text-4xl font-bold text-white pt-16">
          Web Development
        </h1>

        <div className="py-10 flex flex-wrap justify-center gap-6">
          {services.map((card) => (
            <FlipCard
              key={card.id}
              id={card.id}
              frontIcon={card.frontIcon}
              frontTitle={card.frontTitle}
              backText={card.backText}
              borderColor={card.borderColor}
              activeCard={activeCard}
              setActiveCard={setActiveCard}
            />
          ))}
        </div>
      </div>



      <div className='xyz1'>
        <h1 className="font-poppins text-2xl sm:text-3xl md:text-4xl font-bold text-white pt-16">
          Digital Marketing
        </h1>

        <div className="py-10 flex flex-wrap justify-center gap-6">
          {digital.map((card) => (
            <FlipCard
              key={card.id}
              id={card.id}
              frontIcon={card.frontIcon}
              frontTitle={card.frontTitle}
              backText={card.backText}
              borderColor={card.borderColor}
              activeCard={activeCard}
              setActiveCard={setActiveCard}
            />
          ))}
        </div>
      </div>

      <div className='xyz'>
        <h1 className="font-poppins text-2xl sm:text-3xl md:text-4xl font-bold text-white pt-16">
          App Development
        </h1>

        <div className="py-10 flex flex-wrap justify-center gap-6">
          {apps.map((card) => (
            <FlipCard
              key={card.id}
              id={card.id}
              frontIcon={card.frontIcon}
              frontTitle={card.frontTitle}
              backText={card.backText}
              borderColor={card.borderColor}
              activeCard={activeCard}
              setActiveCard={setActiveCard}
            />
          ))}
        </div>
      </div>

      <div className='xyz1'>
        <h1 className="font-poppins text-2xl sm:text-3xl md:text-4xl font-bold text-white pt-16">
          Graphics Design
        </h1>

        <div className="py-10 flex flex-wrap justify-center gap-6">
          {graphics.map((card) => (
            <FlipCard
              key={card.id}
              id={card.id}
              frontIcon={card.frontIcon}
              frontTitle={card.frontTitle}
              backText={card.backText}
              borderColor={card.borderColor}
              activeCard={activeCard}
              setActiveCard={setActiveCard}
            />
          ))}
        </div>
      </div>

      <div className="w-full pt-5 pb-5">
        <hr className="border-t border-white opacity-200" />
      </div>

      <div>
        <h1 className="font-poppins text-2xl sm:text-3xl md:text-4xl font-bold text-white pt-16 pb-5">
          Innovative solutions for the digital age.
        </h1>
        <CircularProgress />
      </div>

      <div className="w-full pt-5 pb-5">
        <hr className="border-t border-white opacity-200" />
      </div>


    </div>
  );
};

export default Services;